jQuery(document).ready(function ($) {
  $('.product-informations .information .label').click(function () {

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next().slideUp();
    } else {
      $('.product-informations .information .label').removeClass('active');
      $('.product-informations .information .value').slideUp();
      $(this).addClass('active');
      $(this).next().slideDown();
    }
  });
  $('.ruk_rating_snippet').on('click', function (e) {
    e.preventDefault();
  })

  $('.afterpay-logo').on('click', function (e) {
    e.preventDefault();
    $('.afterpay-modal-overlay').addClass('visible');
    $('body').addClass('afterpay-modal-visible');
  });

  $('.afterpay-close-button').on('click', function (e) {
    e.preventDefault();
    $('.afterpay-modal-overlay').removeClass('visible');
    $('body').removeClass('afterpay-modal-visible');
  });

  $('.afterpay-modal-overlay').on('click', function (e) {
    if (document.getElementById('afterpay-modal').contains(e.target)) {
      // Clicked in box
    } else {
      $('.afterpay-modal-overlay').removeClass('visible');
      $('body').removeClass('afterpay-modal-visible');
    }
  });

  // Show highest review
  if ($('.highest-rating').length > 0) {
    var highest = null;
    var highestValue = 0;
    $('.highest-rating .reviewWrap').each(function () {
      var value = 0;
      $(this).find('.ruk-icon-percentage-star--100').each(function () {
        value += 20;
      });
      $(this).find('.ruk-icon-percentage-star--75').each(function () {
        value += 15;
      });
      $(this).find('.ruk-icon-percentage-star--50').each(function () {
        value += 10;
      });
      $(this).find('.ruk-icon-percentage-star--25').each(function () {
        value += 5;
      });
      if (value > highestValue) {
        highestValue = value;
        highest = $(this);
      }
    });
    //$('.highest-rating .reviewWrap').hide();
    highest.addClass('active');
  }

  // Click read-more-reviews go to .section-reviews
  $('.read-more-reviews').on('click', function () {
    if ($('.section-reviews').length == 0) {
      return;
    }
    $('html, body').animate({
      scrollTop: $('.section-reviews').offset().top
    }, 1000);
  });
})

jQuery(window).on('load', function () {
  localStorage.removeItem('swym-localwishlist');
  localStorage.removeItem('swym-wishlist');
  sessionStorage.removeItem('swym-session');
  if (typeof SwymProduct !== 'undefined') {
    SwymProduct.init();
  }
})